<template>
  <div>
    <van-loading type="spinner" v-if="nodata"/>
    <div class="about">
      <topIcon :template="dominItem.templateId" :nationId="dominItem.nationId"></topIcon>
    </div>
    <div>
      <div class="logo" :class="[`${dominItem.templateId}`, `${dominItem.templateId}1`]">{{ dominItem.logoName || 'Logo' }}</div>
      <div class="category" :class="`${dominItem.templateId}`">
          <span v-for="item in typeList" @click="changeType(item.id)" :class="[{ choose: current === item.id }]">{{
              item.label
            }}</span>
      </div>
    </div>
    <div style="padding: 0 10%;">
      <div class="news-container">
        <!-- 左侧 TOP STORIES 区域 -->
        <div class="column left">
          <h2 class="section-title world-title">{{ $t('con_recommended') }}</h2>
          <article class="news-item" style="display: flex; align-items: center" v-for="item in articleList"
                   @click="toDetail(item.articleShortName)">
            <img style="width: 100px; height: 100px; border-radius: 20px" :src="item.articleImage" alt="">
            <h3 class="foreHde" style="font-size: 15px; color: #333333; font-weight: 500">
              {{ item.articleTitle }}</h3>
          </article>

        </div>

        <!-- 中间主要内容区域 -->
        <div class="column center">
          <article class="featured-news" @click="toDetail(bestItem.articleShortName)">
            <img :src="bestItem.articleImage"  />
            <h2 class="twoHde">{{ bestItem.articleTitle }}</h2>
            <p class="threeHde">{{ bestItem.articleIntro }}</p>
          </article>

          <div class="news-grid">
            <article class="grid-item" v-for="item in latestNewsList" @click="toDetail(item.articleShortName)">
              <img :src="item.articleImage"  />
              <h3>{{ item.articleTitle }}</h3>
            </article>
          </div>
        </div>

        <!-- 右侧 SPORTS 区域 -->
        <div class="column right">
          <h2 class="section-title sports-title">{{ $t('con_hot_con') }}</h2>
          <article class="news-item" v-for="item in recommendList1" @click="toDetail(item.articleShortName)">
            <img :src="item.articleImage"  />
            <h3 class="twoHde" style="margin-top: 10px">{{ item.articleTitle }}</h3>
            <p class="threeHde">{{ item.articleIntro }}</p>
          </article>
        </div>


      </div>

      <div class="business-news-container111">
        <h2 class="section-header">{{ $t('con_bestnew') }}</h2>
        <div class="news-list">
          <div class="news-item" v-for="item in recommendList" @click="toDetail(item.articleShortName)">
            <img :src="item.articleImage" class="news-image" />
            <div class="news-content">
              <h3 class="news-title twoHde">{{ item.articleTitle }}</h3>
              <p class="news-desc threeHde">{{ item.articleIntro }}</p>
            </div>
          </div>
        </div>
      </div>


      <div class="business-news-container222">
        <h2 class="section-header">{{ $t('con_related') }}</h2>
        <div class="news-list">
          <div class="news-item" v-for="item in latestNewsList1" @click="toDetail(item.articleShortName)">
            <img :src="item.articleImage" class="news-image" />
            <div class="news-content">
              <h3 class="news-title twoHde">{{ item.articleTitle }}</h3>
              <p class="news-desc threeHde">{{ item.articleIntro }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="buttom">
      <div class="explore">
        <span style="color: #fff">{{ $t('con_Explore') }}</span>
        <span  v-for="item in typeList" @click="changeType(item.id)" style="cursor: pointer; color: #ffffff">{{ item.label }}</span>
      </div>
      <div style="display: flex; justify-content: space-between; padding-right: 10%">
        <div class="logo" style="color: #ffffff">{{ dominItem.logoName || 'Logo' }}</div>
        <buttomIcon  v-if="dominItem.nationId !== 'cn'"></buttomIcon>
      </div>
      <footers is00="is02" :articleListlast="articleListlast" :current="current"></footers>

    </div>
  </div>
</template>

<script>
import {getContentList, getLatestNews, getRecommend, getOne, getDomainName} from "@/api"
import topIcon from '../../icons/small.vue'
import buttomIcon from '../../icons/big.vue'
import footers from "@/components/footContent/index.vue"

export default {
  components: {topIcon, buttomIcon, footers},


  props: {
    dominItem: Object
  },

  name: "index",
  data() {
    return {
      bestItem: {},
      nodata: false,
      // template: 'temp3',
      current: 1,
      recommendList:[],
      latestNewsList:[],
      articleList:[],
      latestNewsList1: [],
      articleListlast:[],
      recommendList1: [],
      typeList: [{label: this.$t('con_home'), id: 1},
        {label: this.$t('con_BUSINESS'), id: 2},
        {label: this.$t('con_NEWS'), id: 3},
        {label: this.$t('con_AllPRESS'), id: 4},
        {label: this.$t('con_LIFESTYLE'), id: 5},
        {label: this.$t('con_AUTO'), id: 6},
        {label: this.$t('con_TECHNOLOGY'), id: 7}],
    }
  },
  created() {
    this.nationId = JSON.parse(localStorage.getItem('dominItem')).nationId


    if (this.$route.query.type) {
      this.changeType(Number(this.$route.query.type))
    }else {
      this.getArticleList()
      this.getArticleListlast()
      this.getLatestNewsList()
      this.getRecommendList()
      this.getRecommendList1()
      this.getLatestNewsList1()
      this.getOneList()
    }
  },

  methods: {
    changeType(item) {
      if (item === 8) {
        item = 1
      }
      this.nodata = true
      this.current = item
      this.getArticleList()
      this.getArticleListlast()
      this.getLatestNewsList()
      this.getRecommendList()
      this.getLatestNewsList1()
      this.getRecommendList1()
      this.getOneList()
    },

    // 获取最新的一篇文章
    getOneList() {
      getOne({articleCategoryId: this.current, articleNationId: this.dominItem.nationId}).then(res => {
        if (!res.data.articleImage) {
          res.data.articleImage = require('@/assets/defore.jpg')
        }
        this.bestItem = res.data
        // this.bestInfo.uploadTime = format(new Date(this.bestInfo.uploadTime), this.$t('con_format'))
      })
    },


    // 获取文章列表
    getArticleList() {
      // this.nodata = true
      getContentList({articleCategoryId: this.current,pageNum: this.newsPageNum, pageSize: 8, articleNationId: this.nationId}).then(res => {
        res.rows.map(r=>{
          if (!r.articleImage) {
            r.articleImage = require('@/assets/defore.jpg')
          }
        })
        this.articleList = res.rows
        this.nodata = false
      })
    },

    // 获取最下面文章列表
    getArticleListlast() {
      // this.nodata = true
      getContentList({articleCategoryId: this.current,pageNum: 3, pageSize: 6, articleNationId: this.nationId}).then(res => {
        res.rows.map(r=>{
          if (!r.articleImage) {
            r.articleImage = require('@/assets/defore.jpg')
          }
        })
        this.articleListlast = res.rows
        this.nodata = false
      })
    },

    // 获取最后次更新的文章
    getLatestNewsList() {
      getLatestNews({articleCategoryId: this.current, pageNum: this.newsPageNum, pageSize: 4, articleNationId: this.nationId}).then(res => {
        res.rows.map(r=>{
          if (!r.articleImage) {
            r.articleImage = require('@/assets/defore.jpg')
          }
        })
        this.latestNewsList = res.rows
        this.newsTotal = res.total
      })
    },

    //  获取推荐的文章
    getRecommendList() {
      getRecommend({articleCategoryId: this.current, pageNum: this.recommendPageNum, pageSize: 10,

        articleNationId: this.nationId}).then(res => {
        res.rows.map(r=>{
          if (!r.articleImage) {
            r.articleImage = require('@/assets/defore.jpg')
          }
        })
        this.recommendList = res.rows
      })
    },

    // 获取最后次更新的文章
    getLatestNewsList1() {
      getLatestNews({articleCategoryId: this.current, pageNum: 2, pageSize: 10, articleNationId: this.dominItem.nationId}).then(res => {
        res.rows.map(r=>{
          if (!r.articleImage) {
            r.articleImage = require('@/assets/defore.jpg')
          }
        })
        this.latestNewsList1 = res.rows
        this.newsTotal = res.total
      })
    },

    getRecommendList1() {
      getRecommend({articleCategoryId: this.current, pageNum: this.recommendPageNum, pageSize: 3, articleNationId: this.nationId}).then(res => {
        res.rows.map(r=>{
          if (!r.articleImage) {
            r.articleImage = require('@/assets/defore.jpg')
          }
        })
        this.recommendList1 = res.rows
      })
    },

    //  查看详情
    toDetail(name) {
      this.$router.push(`/details/${name}?type=${this.current}`)
    }
  }
};
</script>

<style scoped lang="scss">
.news-container {
  display: flex;
  justify-content: space-between;
  padding: 20px;
}

.business-news-container111 {
  //max-width: 1200px;
  margin: 0 auto;
  padding: 20px;

  .section-header {
    background-color: #0066cc;
    color: #fff;
    padding: 5px 20px;
    font-size: 14px;

    text-align: left;
    margin-bottom: 15px;
  }

  .news-list {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
  }

  .news-item {
    display: flex;
    border-bottom: 1px solid #eee;
    padding-bottom: 20px;
    margin-bottom: 20px;
  }

  .news-image {
    width: 150px;
    height: 100px;
    object-fit: cover;
    margin-right: 20px;
  }

  .news-title {
    font-size: 15px;
    margin-bottom: 10px;
  }

  .news-desc {
    font-size: 13px;
    color: #666;
    line-height: 1.5;
  }
}

.business-news-container222 {
  //max-width: 1200px;
  margin: 0 auto;
  padding: 20px;

  .section-header {
    background-color: #CC0000;

    color: #fff;
    padding: 5px 20px;
    font-size: 14px;
    text-align: left;
    margin-bottom: 15px;
  }

  .news-list {
    display: grid;
    grid-template-columns: repeat(1, 1fr);
    gap: 20px;
  }

  .news-item {
    display: flex;
    border-bottom: 1px solid #eee;
    padding-bottom: 20px;
    margin-bottom: 20px;
  }

  .news-image {
    width: 250px;
    height: 150px;
    object-fit: cover;
    margin-right: 20px;
  }

  .news-title {
    font-size: 15px;
    margin-bottom: 10px;
  }

  .news-desc {
    font-size: 13px;
    color: #666;
    line-height: 1.5;
  }
}




.column {
  padding: 0 15px;
}

.left,
.right {
  flex: 1;
}

.center {
  flex: 2;
}

.section-title {
  color: #fff;
  padding: 5px 0;
  font-size: 14px;
  text-align: center;
  margin-bottom: 15px;
}

.top-stories-title {
  background-color: #0066cc;
}

.world-title {
  background-color: #0066cc;
}

.sports-title {
  background-color: #cc0000;
}

.news-item {
  margin-bottom: 20px;
}
.news-item img {
  height: 150px;
  width: 100%;
  object-fit: cover;
}

.news-item h3 {
  margin-bottom: 5px;
}

.featured-news {
  margin-bottom: 30px;
}

.featured-news img {
  width: 100%;
  height: auto;
  margin-bottom: 10px;
}

.news-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
}

.grid-item img {
  width: 100%;
  height: 150px;
  object-fit: cover;
  margin-bottom: 10px;
}

.logo {
  width: 80%;
  padding: 10px;
  box-sizing: border-box;
  font-size: 40px;
  font-weight: bold;
  text-align: left;
  margin-left: 10%;
}

.logo-temp1 {
  text-align: center;
}

.logo-temp2 {
  text-align: left;
}

.category {
  width: 100%;
  padding: 0 10%;
  min-height: 50px;
  background: #004F8B;
  margin-bottom: 30px;
  color: #fff;
  //border-top: 2px solid var(--themeColor);
  //border-bottom: 2px solid var(--themeColor);
  line-height: 48px;

  span {
    font-weight: 500;
    font-size: 18px;
    display: inline-block;
    padding: 0 20px;
    cursor: pointer;
    position: relative;
  }

  span:hover {
    color: #EB2127;
    transition: all .1s ease;
  }

  .choose {
    transition: all .1s ease;
    color:red;
  }
}

.buttom {
  border-top: 5px solid #004F8B;
  background: #005DA5;
  display: flex;
  flex-direction: column;

  .logo {
    margin: 0 3% 0 10%;
    width: auto;
  }

  display: flex;

  .explore {
    display: flex;
    justify-content: center;
    margin-top: 30px;
    align-items: center;

    span:first-child {
      color: #004F8B;
      font-size: 18px;
      font-weight: bold;
      margin-right: 30px;
    }

    span {
      margin-right: 10px;
      font-size: 15px;
    }
  }
}

.about {
  cursor: pointer;
  height: 40px;
  line-height: 40px;
  font-weight: 400;
  font-size: 17px;
  text-transform: uppercase;
  display: flex;
  justify-content: end;
  //justify-content: space-between;
  padding-right: 20px;
  color: #ffffff;
  background: #004F8B;
  align-items: center;

  span {
    margin-left: 20px;
    margin-right: 20px;
  }

  img {
    width: 20px;
    height: 20px;
  }

  img:nth-child(4) {
    width: 30px;
    height: 30px;
  }

  img:nth-child(5) {
    width: 30px;
    height: 30px;
  }

  img:nth-child(6) {
    width: 30px;
    height: 30px;
  }
}


.content {
  padding: 0 10% 20px;
  display: flex;
  flex-wrap: wrap;
  span{
    display: inline-block;
    margin-bottom: 10px;
    width: 50%;
  }
}

</style>